<template>
  <tr v-on:click.stop="toggleSelection" style="cursor: pointer; user-select: none">
    <td class="is-clickable"><input type="checkbox" v-model="model" v-if="isSelectable" /></td>
    <td class="is-clickable">{{ item.product_id }}</td>
    <td class="is-clickable"><strong>{{ item.product_name }}</strong>
      <div>
        <span v-if="reservation" style="font-weight: bold; color: #666">
          {{ getReservationDesc(reservation) }}
          <small style="color: #999" v-if="previousReservation"><br />({{ _('was') }} {{ getReservationDesc(previousReservation) }})</small>
          <template v-if="item.rateplan_name"><br />{{ item.rateplan_name }}</template>
        </span>
        <span v-else-if="item.reservation_desc" style="font-weight: bold; color: #666">
          <small style="color: #999">({{ item.reservation_desc }})</small>
        </span>
        <div v-if="item.pricetiers" v-html="getPricetierDescription(item)"></div>
        <div v-else-if="item.reservation_count">{{ _('Participants') }}: {{ item.reservation_count }}</div>
        <div class="alert alert-info" style="display: inline-block; margin-bottom: 0; margin-top: 5px; padding-top: 8px; padding-bottom: 8px;" v-if="item.special">{{ item.special }}</div>
      </div>
    </td>
    <td class="is-clickable">{{ item.count }}</td>
    <td class="is-clickable">{{ $filters.currency(item.price, settings.currency) }}</td>
  </tr>
</template>

<script>
import { DateTime } from 'luxon'
import components from '~/lib/components'

export default {
  mixins: [components],
  props: ['value', 'item', 'delivery', 'selected'],
  computed: {
    model: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    isSelectable () {
      if (!this.delivery) {
        return true
      }
      if (parseInt(this.delivery.processed) || this.delivery.shipit_status) {
        return false
      }
      return true
    },
    reservation () {
      return this.item && this.item.ownReservation && this.item.ownReservation[0] ? this.item.ownReservation[0] : null
    },
    previousReservation () {
      if (!this.reservation) {
        return null
      }
      if (this.item.start_ts !== this.reservation.start_ts || this.item.end_ts !== this.reservation.end_ts) {
        return { start_ts: this.item.start_ts, end_ts: this.item.end_ts }
      }
      return null
    }
  },
  methods: {
    toggleSelection () {
      if (this.isSelectable) {
        this.model = !this.model
      }
    },
    getPricetierDescription (item) {
      if (!item.pricetiers || !item.product || !item.product.sharedPricetier || !item.product.sharedPricetier.length) {
        return ''
      }
      const tiers = item.pricetiers.split(';')
      let ret = []
      for (let i = 0; i < tiers.length; i++) {
        let [id, count] = tiers[i].split(':')
        const pt = item.product.sharedPricetier.find(p => parseInt(p.id, 10) === parseInt(id, 10))
        if (pt) {
          ret.push(pt.name + ': ' + count)
        }
      }
      return ret.join(', ')
    },
    getReservationDesc(reservation) {
      let s = ''
      const _ = this._
      const sd = DateTime.fromSeconds(Number(reservation.start_ts), { zone: this.timezone })
      let ed = DateTime.fromSeconds(Number(reservation.end_ts), { zone: this.timezone })
      let et = ed.toFormat(this.timeFormat)
      if (et === '0.00') {
        et = '24.00'
        ed = ed.minus({ days: 1 })
      }
      s += sd.toFormat(this.dateFormat) + ' ' + _('at') + ' ' + sd.toFormat(this.timeFormat)
      s += ' - '
      if (sd.toFormat('yyyy/MM/dd') !== ed.toFormat('yyyy/MM/dd')) {
        s += ed.toFormat(this.dateFormat) + ' ' + _('at') + ' '
      }
      s += et
      return s
    }
  }
}
</script>